import React from 'react';
import FeaturedCategoriesTable from '../components/CategoriesTable';

export function FeaturedCategories() {
  return <FeaturedCategoriesTable />;
}
